import React, { useState, useEffect } from 'react';
import AppSettingServices from '../services/AppSettingServices';
import useAsync from '../hooks/useAsync';

function AppGSetting() {
    const { data, error, isLoading } = useAsync(AppSettingServices.getAppSettingDetail);
    console.warn("saddsfsdf", data.data);


    const [formValues, setFormValues] = useState({
        description: '',
        paynowLimit: 0,
        vendorLeaveLimit: 0,
       
    });


    useEffect(() => {
        if (data.data) {
            setFormValues({
                description: data.data.description || '',
                paynowLimit: data.data.paynowLimit || 0,
                vendorLeaveLimit: data.data.vendorLeaveLimit || 0,
               
            });
        }
    }, [data]);


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await AppSettingServices.updateAppSettingDetail(data.data._id, formValues);
            alert('App settings updated successfully');
        } catch (error) {
            console.error('Failed to update app settings', error);
            alert('Failed to update app settings');
        }
    };


    if (isLoading) {
        return <div className="loader design_loading">Loading...</div>;
    }

    if (error) {
        return <div>Error loading contact details</div>;
    }

    return (
        <div className="right_col" role="main">

                 <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
            
                      <div className="my-auto">
            
                        <h5 className="page-title fs-21 mb-1">
                        App Text Change                     </h5>
                        <nav>
            
                          <ol className="breadcrumb mb-0">
            
                            <li className="breadcrumb-item">
                              <a href="javascript:void(0);">Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                            App Text
                            </li>
                          </ol>
                        </nav>
                      </div>
                      <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        
            
            
            
                      </div>
                    </div>
           
            <div className="container-box">
                <div className="container-box-inner table-reponsive-tabe">
                    <div className="page-details appchangedetails">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label>App Home Screen Footer</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <textarea
                                                type="text"
                                                name="description"
                                                className="form-control"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                rows={2}
                                                cols={10}
                                                required
                                                maxLength={100}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label>Paynow Limit</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <input
                                                type="number"
                                                name="paynowLimit"
                                                className="form-control"
                                                value={formValues.paynowLimit}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label>Vendor Leave Limit</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <input
                                                type="number"
                                                name="vendorLeaveLimit"
                                                className="form-control"
                                                value={formValues.vendorLeaveLimit}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <button type="submit" className="submit-green-btn1 ss-tt">SUBMIT</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppGSetting;
